import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

const AdminActions = {
    AdminLogin: createAsyncThunk("AdminLogin", async (data) => {
        const response = await API.post('admin/login', data);
        return response.data;
    }),
    verifyOtp: createAsyncThunk("verifyOtp", async (data) => {
        const response = await API.post('verifyotp', data);
        return response.data;
    }),
    resendOtp: createAsyncThunk("resendOtp", async (data) => {
        const response = await API.post('resendOtp', data);
        return response.data;
    }),
    updateFile: createAsyncThunk("updateFile", async (payload) => {
        const data = await API.post("profile/uploadImage", payload);
        return { data };
    }),
    getAdminDetails: createAsyncThunk("getAdminDetails", async () => {
        const response = await API.get('profile/fetch');
        return response.data;
    }),
    createAdministrator: createAsyncThunk("createAdministrator", async (data) => {
        const response = await API.post('sub/create', data);
        return response.data;
    }),
    editAdministrator: createAsyncThunk("editAdministrator", async (data) => {
        const response = await API.put('sub/edit', data);
        return response.data;
    }),
    deleteBot: createAsyncThunk("deleteBot", async ({ chatbotId }) => {
        const response = await API.delete(`chatbot/${chatbotId}`);
        return response.data;
    }),
    deleteAdmin: createAsyncThunk("deleteAdmin", async ({ adminId }) => {
        const response = await API.delete(`admin/delAdminController?adminId=${adminId}`);
        return response.data;
    }),
    deleteFaq: createAsyncThunk("deleteFaq", async ({ faqId }) => {
        const response = await API.delete(`faq/${faqId}`);
        return response.data;
    }),
    deletePrompt: createAsyncThunk("deletePrompt", async ({ promptId }) => {
        const response = await API.delete(`prompt/${promptId}`);
        return response.data;
    }),
    deleteNotification: createAsyncThunk("deleteNotification", async ({ notificationId }) => {
        const response = await API.delete(`deleteNotification/${notificationId}`);
        return response.data;
    }),
    deleteReport: createAsyncThunk("deleteReport", async ({ userId }) => {
        const response = await API.delete('deleteReport', {
            params: { userId }
        });
        return response.data;
    }),
    userAction: createAsyncThunk("userAction", async (data) => {
        const response = await API.put('activateDeactivateUser', data);
        return response.data;
    }),
    reportAction: createAsyncThunk("reportAction", async (data) => {
        const response = await API.put('changeReportStatus', data);
        return response.data;
    }),
    reviewAction: createAsyncThunk("reviewAction", async (data) => {
        const response = await API.put('verifyReview', data);
        return response.data;
    }),
    verifyUser: createAsyncThunk("verifyUser", async (data) => {
        const response = await API.put('verifyUser', data);
        return response.data;
    }),
    getAdministrator: createAsyncThunk("getAdministrator", async ({ page, limit, search }) => {
        const response = await API.get('sub/list', {
            params: { page, limit, search }
        });
        return response.data;
    }),

    createFaq: createAsyncThunk("createFaq", async (data) => {
        const response = await API.post('faq/create', data);
        return response.data;
    }),
    editFaq: createAsyncThunk("editFaq", async (data) => {
        const response = await API.put('faq/update', data);
        return response.data;
    }),
    getFaq: createAsyncThunk("getFaq", async ({ page, limit, search }) => {
        const response = await API.get('faq/list', {
            params: { page, limit, search }
        });
        return response.data;
    }),
    deleteFaq: createAsyncThunk("deleteFaq", async ({ faqId }) => {
        const response = await API.delete(`faq/${faqId}`);
        return response.data;
    }),
    createResource: createAsyncThunk("createResource", async (data) => {
        const response = await API.post('resource/create', data);
        return response.data;
    }),
    createNotification: createAsyncThunk("createNotification", async (data) => {
        const response = await API.post('addNotification', data);
        return response.data;
    }),
    getResource: createAsyncThunk("getResource", async ({ page, limit, search }) => {
        const response = await API.get('resource/all', {
            params: { page, limit, search }
        });
        return response.data;
    }),
    deleteResource: createAsyncThunk("deleteResource", async ({ id }) => {
        const response = await API.delete(`resource/delete`, {
            params: { id }
        });
        return response.data;
    }),
    getTransactions: createAsyncThunk("getTransactions", async ({ page, limit, search }) => {
        const response = await API.get('transaction/list', {
            params: { page, limit, search }
        });
        return response.data;
    }),
    updateTransactionStatus: createAsyncThunk("updateTransactionStatus", async (data) => {
        const response = await API.put('transaction/update', data);
        return response.data;
    }),
}

export default AdminActions